import React, { useState, useCallback, useRef } from "react";
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  Polyline,
  OverlayView,
} from "@react-google-maps/api";
import { GOOGLE_MAP_KEY } from "../../Utils/Utils";
import { useMyLocation } from "../../hooks/LocationContext";

const containerStyle = {
  width: "100%",
  height: "80vh",
  borderRadius: "10px",
};

// 🟢 Default center set to Nashik


const mapOptions = {
  streetViewControl: false,
  mapTypeControl: false,
  fullscreenControl: true,
  zoomControl: true,
};

const TrackFlight = () => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: GOOGLE_MAP_KEY,
  });
  const { location: currentLocation, loaded } = useMyLocation();
  console.log("current my location1", currentLocation);
const center = {
  lat: currentLocation.lat, lng: currentLocation.lng
};
  const [flightId, setFlightId] = useState("");
  const [flightPath, setFlightPath] = useState([]);
  const [currentPosition, setCurrentPosition] = useState(center); // 🟢 Start from Nashik
  const [error, setError] = useState("");
  const mapRef = useRef(null);

  const onLoad = useCallback((map) => {
    mapRef.current = map;
  }, []);

  const fetchFlightLocation = async (id) => {
    try {
      setError("");
      if (!id) {
        setError("Please enter a flight ID");
        return;
      }

      // Example simulated API call (replace with real API)
      const response = await fetch(
        `https://api.flightapi.io/track/${id}?token=YOUR_FLIGHT_API_KEY`
      );
      if (!response.ok) throw new Error("Flight not found");
      const data = await response.json();

      // 🟢 Example: fallback to Nashik if no data found
      const lat = data?.position?.latitude ||  currentLocation.lat;
      const lng = data?.position?.longitude || currentLocation.lng;

      const newPos = { lat, lng };
      setCurrentPosition(newPos);
      setFlightPath((prev) => [...prev, newPos]);

      // Center map on flight
      if (mapRef.current) {
        mapRef.current.panTo(newPos);
        mapRef.current.setZoom(8);
      }
    } catch (err) {
      console.error("Error fetching flight data:", err);
      setError("Could not fetch flight data. Try again.");
    }
  };

  const handleTrackFlight = () => {
    fetchFlightLocation(flightId);

    const interval = setInterval(() => {
      fetchFlightLocation(flightId);
    }, 30000);

    return () => clearInterval(interval);
  };

  if (!isLoaded) return <div>Loading Map...</div>;

  return (
    <div className="p-6">
      {/* <h2 className="text-xl font-semibold mb-4">✈️ Track Flight</h2> */}

      {/* <div className="flex items-center gap-3 mb-4">
        <input
          type="text"
          placeholder="Enter Flight ID (e.g., AI202)"
          value={flightId}
          onChange={(e) => setFlightId(e.target.value)}
          className="w-64 border p-2 rounded"
        />
        <button
          onClick={handleTrackFlight}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Track Flight
        </button>
      </div> */}

      {/* {error && <p className="text-red-600 mb-2">{error}</p>} */}

      <GoogleMap
        mapContainerStyle={containerStyle}
        center={currentPosition}
        zoom={8}
        onLoad={onLoad}
        options={mapOptions}
      >
        {currentPosition && (
        <OverlayView
            position={currentPosition}
            mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
        >
            <img
            src="/images/airplane1.png"  // 🟡 use your uploaded image
            alt="plane"
            style={{
                width: "50px",
                height: "50px",
                transform: "translate(-50%, -50%) rotate(0deg)", // center + direction angle
                filter: "drop-shadow(2px 2px 4px rgba(0,0,0,0.4))",
            }}
            />
        </OverlayView>
        )}

        {flightPath.length > 1 && (
          <Polyline
            path={flightPath}
            options={{
              strokeColor: "#1E90FF",
              strokeOpacity: 0.8,
              strokeWeight: 3,
            }}
          />
        )}
      </GoogleMap>
    </div>
  );
};

export default TrackFlight;
